import styled from 'styled-components';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AppWrapper = styled.div<{ $isLoggedIn?: any }>`
  width: 100%;
  height: 100%;
  display: flex;
  background-color: ${({ theme, $isLoggedIn }) => $isLoggedIn && theme.colors.AccentPurple};
`;
